<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <div class="ac-bubble-wrapper">
        <div class="ac-bubble-container">
          <div class="ac-label">
            Account Holder Name
          </div>
          <div class="ac-text">
            {{ billingAddress.firstName }} {{ billingAddress.lastName }}
          </div>
        </div>
        <div class="ac-bubble-container">
          <div class="ac-label">
            Financial Institution
          </div>
          <div class="ac-text">
            {{ setupIntent.payment_method.us_bank_account.bank_name }}
          </div>
        </div>
        <div class="ac-bubble-container">
          <div class="ac-label">
            Routing Number
          </div>
          <div class="ac-text">
            {{ setupIntent.payment_method.us_bank_account.routing_number }}
          </div>
        </div>
        <div class="ac-bubble-container">
          <div class="ac-label">
            Account Number
          </div>
          <div class="ac-text">
            ****{{ setupIntent.payment_method.us_bank_account.last4 }}
          </div>
        </div>
      </div>
      <div class="ac-body">
        By clicking [accept], you authorize SmartAC.com to debit
        the bank account specified above for any amount owed for
        charges arising from your use of SmartAC.com' services and/
        or purchase of products from SmartAC.com, pursuant to
        SmartAC.com' website and terms, until this authorization is
        revoked. You may amend or cancel this authorization at any
        time by providing notice to SmartAC.com with 30 (thirty)
        days notice.
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-cancel-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="confirmIntent"
      >
        Accept
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
    />
  </div>
</template>

<script>
import axios from 'axios';

import apiClient from '@shared/lib/general/apiClient';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ConfirmMandate',
  components: {
    ProcessOverlay,
  },
  props: {
    billingAddress: Object,
    setupIntent: Object,
    changes: Function,
    onSubmit: Function,
    toggleActionModal: Function,
  },
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async confirmPaymentIntent() {
      const {
        id,
      } = this.setupIntent;
      const { data: ip } = await axios({
        method: 'GET',
        url: 'https://api.ipify.org',
      });
      const { data } = await apiClient({
        method: 'PUT',
        url: `/stripe/intent/${id}/confirm`,
        data: {
          ip,
          userAgent: window.navigator.userAgent,
        },
      });
      return data;
    },
    async confirmIntent() {
      this.processing = true;
      const intent = await this.confirmPaymentIntent();
      if (!intent.next_action) {
        this.changes([{
          field: 'paymentMethodId',
          value: intent.payment_method,
        }, {
          field: 'paymentMethod',
          value: 'Direct Debit',
        }]);
        try {
          await this.onSubmit();
        } catch (err) {
          console.error(err);
        }
      } else {
        this.toggleActionModal(true, 'verification-required');
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.ac-body-container {
  display: flex;
  flex-direction: column;
  .ac-bubble-wrapper {
    display: flex;
    flex-wrap: wrap;
    .ac-bubble-container {
      width: 50%;
      margin-bottom: 12px;
      background-color: $N10;
      padding: 8px;
      .ac-label {
        font-size: 0.875rem;
      }
      .ac-text {
        font-weight: 700;
        font-size: 1.125rem;
      }
    }
  }
  .ac-body {
    font-weight: 500;
    margin-top: 8px;
  }
}
</style>
